import { c as _c } from "react/compiler-runtime";
import { VillaSearchPropertiesType } from "@website/accommodation-ui/villa-search/villa-search.types";
import { DatepickerSelectedDateType } from "@website/ui/datepicker";
import { useEffect, useState } from "react";
export const useValidation = t0 => {
  const $ = _c(16);
  const {
    acceptEmpty: t1,
    selectedDestinationItem,
    date,
    initialDestinationItem,
    searchType
  } = t0;
  const acceptEmpty = t1 === undefined ? false : t1;
  const [destinationError, setDestinationError] = useState("");
  const [dateError, setDateError] = useState("");
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setDestinationError("");
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== selectedDestinationItem) {
    t3 = [selectedDestinationItem];
    $[1] = selectedDestinationItem;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setDateError("");
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== date) {
    t5 = [date];
    $[4] = date;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] !== acceptEmpty || $[7] !== date || $[8] !== initialDestinationItem || $[9] !== searchType || $[10] !== selectedDestinationItem) {
    t6 = () => {
      let hasError = false;
      if (!(selectedDestinationItem || initialDestinationItem) && searchType !== "villa") {
        setDestinationError("\u0644\u0637\u0641\u0627 \u0645\u0642\u0635\u062F \u062E\u0648\u062F \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u0646\u0645\u0627\u06CC\u06CC\u062F.");
        hasError = true;
      }
      if ((!date || !date[0] || !date[1]) && !acceptEmpty) {
        setDateError("\u0644\u0637\u0641\u0627 \u062A\u0627\u0631\u06CC\u062E \u0648\u0631\u0648\u062F \u0648 \u062E\u0631\u0648\u062C \u062E\u0648\u062F \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u0646\u0645\u0627\u06CC\u06CC\u062F.");
        hasError = true;
      }
      return !hasError;
    };
    $[6] = acceptEmpty;
    $[7] = date;
    $[8] = initialDestinationItem;
    $[9] = searchType;
    $[10] = selectedDestinationItem;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const submitValidationCheck = t6;
  let t7;
  if ($[12] !== dateError || $[13] !== destinationError || $[14] !== submitValidationCheck) {
    t7 = {
      dateError,
      destinationError,
      submitValidationCheck
    };
    $[12] = dateError;
    $[13] = destinationError;
    $[14] = submitValidationCheck;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};